import type { IkonAdi } from "./Ikon";

/**
 * YARDIM KATEGORİSİ → İKON — UI/UX Dalga 2 (M10)
 *
 * Kategori adı sunucudan serbest metin geliyor (yönetici düzenleyebilir); bu
 * sözlük yalnız GÖRSEL ipucu: tanınmayan kategori "yardim" ikonunu alır, hiçbir
 * kategori ikonsuzdan dolayı gizlenmez. İkon metnin yerine geçmiyor, yanında
 * duruyor (`Ikon` zaten `aria-hidden`).
 */
const KATEGORI_IKONU: Readonly<Record<string, IkonAdi>> = {
  "İlk gün": "bugun",
  "Nasıl yaparım": "yardim",
  Program: "program",
  Deneme: "deneme",
  Denemeler: "deneme",
  "Günlük çalışma": "bugun",
  "Görüşme ve rapor": "rapor",
  "Hesap ve güvenlik": "guvenlik",
  "Mesaj ve istekler": "gorusme",
  İletişim: "gorusme",
  Operasyon: "duyuru",
  "Satış ve finans": "finans",
  "Sık sorulanlar": "yardim",
  "Çocuğumun durumu": "ogrenci",
  "Öğrenci kaydı": "ogrenci",
  Gelişim: "risk",
  Ekranlar: "gorunum",
  Kısayollar: "teknik",
};

export function yardimKategoriIkonu(kategori: string): IkonAdi {
  return KATEGORI_IKONU[kategori] ?? "yardim";
}
